import React from "react";
import styled from "styled-components";

//Cabecera en caso de politicas
const CabeceraPol = (props) => {
  
  return (
    <Contenedor > 
      <EstiloH2 className="mb-4" letra="true">
        {props.Titulo}
      </EstiloH2>
      
    </Contenedor>
  );
};

export default CabeceraPol;

const Contenedor = styled.div`
  width: 100%;
  height: 60px;
  background-color: #efefef; 
  
  text-align: center;
  
    
    h2{
        float: left;
        margin-left: 20%;
        margin-top: 1%;
    }
  
  
`;

const EstiloH2 = styled.h2`
  font-family: "Roboto";
  font-weight: 400;
  font-size: 24px;
`;








